import React from 'react'

export const WarningRed = (props) => {
  return (
    <div className={`flex items-center h-14 rounded-lg space-x-4 px-4 py-5 border bg-[#FDEFE9] border-[#F7C9B3] my-4`}>
    <svg xmlns="http://www.w3.org/2000/svg" focusable="false" role="img" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" className="w-5 h-5 text-[#B16300]"><path fillRule="evenodd" d="M12.432 2.248a.5.5 0 00-.864 0l-10.5 19a.5.5 0 00.433.752H22.5a.5.5 0 00.432-.752l-10.5-19zm.569 12.502a.25.25 0 01-.25.25h-1.5a.25.25 0 01-.25-.25v-5.5a.25.25 0 01.25-.25h1.5a.25.25 0 01.25.25v5.5zm0 4a.25.25 0 01-.25.25h-1.5a.25.25 0 01-.25-.25v-1.5a.25.25 0 01.25-.25h1.5a.25.25 0 01.25.25v1.5z" clipRule="evenodd"></path></svg>
         <div className='flex-1'>
          <div>
            {props.heading &&
        <span className=' text-base'>
        {props.heading}
        </span>
}
        <p className='text-sm '>
        {props.paragraph} {props?.link && <span className='font-bold text-[#0078ae] '>{props?.link}</span>}
        </p></div></div>
    </div>
  )
}
